<div
  *ngFor="let color of colors"
  [style.background-color]="color"
  (click)="onSelect(color)"
  [class.disabled]="isDisabled"
  [class.active]="activeColor === color"
></div>
